import { IconPropsType } from '../types';

const DEFAULT_WIDTH = 138;
const DEFAULT_HEIGHT = 32;
const ASPECT_RATIO = DEFAULT_WIDTH / DEFAULT_HEIGHT;

const CoyuLogo = ({ size, width, height, ...props }: IconPropsType) => {
  const resolvedWidth = width ?? size ?? DEFAULT_WIDTH;
  const resolvedHeight =
    height ?? (typeof resolvedWidth === 'number' ? resolvedWidth / ASPECT_RATIO : DEFAULT_HEIGHT);

  return (
    <svg
      width={resolvedWidth}
      height={resolvedHeight}
      viewBox="0 0 138 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.904 12.733c.465 1.858.756 3.507.756 5.058 0 2.992-1.098 5.525-4.065 8.238-2.574 2.394-5.7 4.182-9.06 5.386a9.7 9.7 0 0 1-3.308.57c-3.526 0-6.98-1.774-9.874-3.715-1.273-.877-2.661-1.621-3.898-2.547-1.84-1.342-2.77-3.458-3.453-5.524-.953-2.957-2.305-5.727-2.553-8.892-.036-.279-.036-.557-.036-.828 0-2.032.99-3.772 2.603-5.268 1.193-1.113 2.647-2.163 4.16-2.887A25.5 25.5 0 0 1 47.44.445C48.858.083 50.21 0 51.504 0c4.552 0 8.544 2.22 12.223 5.232.509.397 1.062.773 1.636 1.1 1.047.654 2.269.98 3.272 1.67l.036.034c1.513 1.065 1.782 3.062 2.233 4.697m-.916 5.761c0-.842-.233-1.649-.808-2.268-.85-.828-2.34-1.002-3.475-1.621-1.469-.703-2.494-1.963-3.309-3.333-1.33-2.255-2.98-4.356-5.01-6.04-1.388-1.106-3.06-1.809-4.784-2.344a12.6 12.6 0 0 0-3.904-.599c-3.65 0-7.352 1.51-9.831 4.112-1.098 1.134-2.014 2.596-2.014 4.252 0 1.802 1.098 3.367 2.516 4.418 1.367.967 3.075 1.621 4.333 2.86.807.786 1.49 1.732 2.174 2.664 1.55 2.102 3.163 4.196 5.374 5.608 2.087 1.343 4.551 1.997 6.995 1.997 4.428 0 9.496-2.477 11.219-7.173l.022-.035c.269-.758.501-1.656.501-2.498"
        fill="#fff"
      />
      <path
        d="M137.31 17.462v-17h-4.636v18.751c0 4.364-1.279 11.397-9.934 11.397-9.781 0-10.442-8.165-10.442-11.772V.463h-4.855v16.755c0 10.23 5.378 14.782 15.057 14.782 9.309 0 14.81-4.468 14.81-14.538M70.919.463l13.57 21.286-.036 9.893h4.667v-9.941L103.375.463h-2.104L88.559 19.81 76.41.463zm-38.556 22.09-4.565.187c-2.694 3.506-6.4 5.116-11.307 5.324-7.34.313-14.672-4.7-14.883-11.793l-.014-.007C1.535 9.232 8.554 3.956 15.85 3.929c4.907-.021 8.693 1.416 11.57 4.796l4.266-.02C29.086 3.122 23.211.061 16.658.09 10.702.11 5.27 3.248 2.343 8.177-.824 13.515-.94 20.79 2.977 25.808c3.225 4.13 8.599 6.109 13.892 6.088 3.488-.014 6.91-.937 9.75-2.721 2.562-1.576 4.608-3.811 5.744-6.622"
        fill="#fff"
      />
    </svg>
  );
};
export default CoyuLogo;
